import React, { useEffect } from 'react';
import { ModalWrapper, ModalBox, CloseButtonWrapper, CloseButton, IconWrapper, HeaderWrapper, CheckMark, Title, Message  } from './SuccessModal.styled';
import { ReactComponent as CheckIconBlue } from '../../icon/assets/check_modal.svg';


const Modal = ({ isOpen, onClose, title, message, className, autoClose = false, autoCloseTime = 2000  }) => {
  useEffect(() => {
    let timeoutId;
    if (isOpen && autoClose) {
      timeoutId = setTimeout(() => {
        onClose();
      }, autoCloseTime);
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isOpen, onClose, autoClose, autoCloseTime]);

  return (
    <ModalWrapper $isOpen={isOpen} className={className}>
      <ModalBox>
        <CloseButtonWrapper>
          <CloseButton onClick={onClose}>✕</CloseButton>
        </CloseButtonWrapper>
        <HeaderWrapper>
          <IconWrapper>
            <CheckMark>
              <CheckIconBlue />
              </CheckMark>
          </IconWrapper>
          <Title>{title}</Title>
        </HeaderWrapper>
        <Message>{message}</Message>
      </ModalBox>
    </ModalWrapper>
  );
};

export default Modal;
